/**
  * 专业/班级模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const organizationApi = {
    GetspecialtynList: `${base.qa}/Organization/GetspecialtynList`,
    SaveSpecialty: `${base.qa}/Organization/SaveSpecialty`,//添加修改专业
    GetOrganizationInfo: `${base.qa}/Organization/GetOrganizationInfo`,//根据id查询信息
    DelOrganization: `${base.qa}/Organization/DelOrganization`,//删除

    GetClassList: `${base.qa}/Organization/GetClassList`,
    GetOrgDataTree: `${base.qa}/Organization/GetOrgDataTree`,//获取专业班级树形图
    SaveClass: `${base.qa}/Organization/SaveClass`,//修改班级


}

const organization = {
    GetspecialtynList (params) {
        return axios.get(organizationApi.GetspecialtynList, { params: { ispage: false } })
    },
    SaveSpecialty (params) {
        return axios.post(organizationApi.SaveSpecialty, params)
    },
    GetOrganizationInfo (orgid) {
        return axios.get(organizationApi.GetOrganizationInfo, { params: { orgid } })
    },
    DelOrganization (params) {
        return axios.post(organizationApi.DelOrganization, params)
    },
    GetClassList (specialtyid) {
        return axios.get(organizationApi.GetClassList, { params: { specialtyid, ispage: false } })
    },
    GetOrgDataTree () {
        return axios.get(organizationApi.GetOrgDataTree)
    },
    SaveClass (params) {
        return axios.post(organizationApi.SaveClass, params)
    },
}


export default organization;